import contextMenu from 'helpers/styles/contextMenu'

export default {
  LineLengthOverlay: {
    backgroundColor: 'white',
    display: 'inline',
    padding: '.5rem',
    lineHeight: '.5rem',
    position: 'absolute'
  },
  ...contextMenu
}



// WEBPACK FOOTER //
// ./src/components/Markup/style.js